<template>
	<Row class="page-container-row">
		<Col
			:span="24"
			:offset="0"
		>
			<PageContainer>
				<TypographyTitle :level="2">
					{{ $t('insights.header') }}
				</TypographyTitle>
				<MasonryContainer>
					<MasonryItem headerKey="insights.roverPerformanceTest.header">
						<RoverPerformanceTest />
					</MasonryItem>
				</MasonryContainer>
			</PageContainer>
		</Col>
	</Row>
</template>

<script>
import { TypographyTitle, Row, Col } from 'ant-design-vue';

import PageContainer from '@/components/common/PageContainer';
import MasonryContainer from '@/components/masonry/MasonryContainer';
import MasonryItem from '@/components/masonry/MasonryItem';

import RoverPerformanceTest from '@/components/insights/RoverPerformanceTest.vue';


export default {
	components: {
		TypographyTitle, Row, Col, PageContainer,
		MasonryContainer, MasonryItem,
		RoverPerformanceTest,
	},
	setup() {
		return {
		};
	},
}
</script>
